module.exports = __webpack_public_path__ + "img/icon-doctor-line.ba8109f.svg";